import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Text } from 'recharts';
import Header from '../../components/PublicHeader';
import PublicFooter from '../../components/PublicFooter';
import { getAccounts, reIdentity } from '../../actions/Accounts';
import { isAuthenticated, sendLogin, signOut } from '../../auth/Auth';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { removeToken } from '../../libs/apis/UserApi';
import { getGroupIdentities } from '../../actions/Identity';

const styles = () => ({
  '@global': {
    body: {
      backgroundColor: '#F7F7F7',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    }
  },
  main: {
    flexGrow: 1,
    maxWidth: 375,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 20
    // border: '1px solid #ccc'
  },
  page: {
    paddingLeft: 15,
    paddingRight: 15
  },
  paper: {
    display: 'flex',
    flexDirection: 'column'
  },
  titleGroup: {
    marginTop: 20,
    marginBottom: 20,
    display: 'flex',
    alignItems: 'flex-start'
  },
  pagerInDiv: {
    padding: '15px 10px'
  },
  linkToHome: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 50
  },
  shopHeader: {
    padding: 5,
    color: '#ffffff',
    textAlign: 'center',
    backgroundColor: '#FFD0D5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    position: 'relative',
    marginBottom: 20,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',

    '&:before': {
      content: '""',
      position: 'absolute',
      left: '50%',
      bottom: '-12px',
      transform: 'translateY(-50%)',
      display: 'inline-block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '8px 5px 0 5px',
      borderColor: '#FFD0D5 transparent transparent transparent'
    }
  },
  tableInfo: {
    width: '100%',
    marginBottom: 10
  },
  tableInfoCellHeader: {
    padding: '5px 10px',
    width: '60px',
    borderBottom: '2px solid #ffffff',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#000000',
    backgroundColor: '#F7F7F7',
    whiteSpace: 'nowrap'
  },
  tableInfoCell: {
    padding: '2px 10px',
    borderBottom: '2px solid transparent',
    fontSize: '12px',
    whiteSpace: 'break-spaces'
  },
  titleGroupNameDiv: {
    padding: '5px 12px',
    zIndex: 150
  },
  titleGroupName: {
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: '13px',
    color: 'black'
  },
  textGroupNameDiv: {
    padding: '5px 12px',
    zIndex: 150
  },
  textGroupName: {
    fontSize: 20,
    fontWeight: 'bold',
    lineHeight: '16px',
    color: 'red',
    whiteSpace: 'break-spaces'
  },
  textShopId: {
    fontSize: 10,
    fontWeight: 'normal',
    lineHeight: '13px',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  textShopName: {
    fontWeight: 'bold',
    fontSize: 16,
    lineHeight: '21px',
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: 5,
    whiteSpace: 'break-spaces'
  },
  bold: {
    fontWeight: 'bold'
  },
  adminMemo: {
    border: '1px solid #ccc',
    borderRadius: 4,
    padding: 10
  },
  ngReason: {
    padding: '15px 0'
  },
  font24: {
    fontSize: 24
  },
  font14: {
    fontSize: 14
  },
  breakLine: {
    whiteSpace: 'pre-line'
  },
  btnBack: {
    padding: 0,
    minWidth: 0
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      cognitoUserId: state.cognitoUser.cognitoUserId
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getAccounts, getGroupIdentities, reIdentity },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('released', 'setReleased', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('identity', 'setIdentity', {}),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.updateOpenProgress(true);
      this.props.updateLoading(true);
      this.props.actions
        .getAccounts({
          cognitoUserId: this.props.cognitoUserId
            ? this.props.cognitoUserId
            : ''
        })
        .then(data => {
          this.props.checkSession(data);
          if (data.payload.groupAccountStatus != null) {
            if (data.payload.groupAccountStatus.status) {
              // Redirect to Home page if account status is released
              this.props.handleRedirect('/home_group');
              return;
            }
            this.props.setReleased(data.payload.groupAccountStatus.status);
          }
          this.props.actions
            .getGroupIdentities({
              page: 1,
              limit: 100
            })
            .then(identityData => {
              this.props.checkSession(identityData);
              const identities = _.get(identityData, 'payload.identities', []);
              if (identities.length > 0) {
                const sortIdentities = _.sortBy(identities, ['registeredAt']);
                const identity = sortIdentities[sortIdentities.length - 1];
                this.props.setIdentity(identity);
              }
              this.props.updateOpenTable(true);
              this.props.updateOpenProgress(false);
              this.props.updateLoading(false);
            })
            .catch(() => {
              this.props.updateOpenProgress(false);
              this.props.updateLoading(false);
            });
        })
        .catch(() => {
          this.props.updateOpenProgress(false);
          this.props.updateLoading(false);
        });
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleRedirect,
    released,
    openTable,
    openProgress,
    updateOpenProgress,
    loading,
    resultMessage,
    identity,
    actions
  }) => {
    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const signOutAction = async () => {
      // remove token
      const currentToken = localStorage.getItem('firebaseToken');
      removeToken({
        pushToken: currentToken
      })
        .then(() => {
          console.log('remove token success');
        })
        .catch(() => {
          console.log('remove token failed');
        });

      signOut();
      handleRedirect('/');
    };

    const handleReIdentity = () => {
      actions.reIdentity(true);
      handleRedirect('/release_group');
    };

    return (
      <Container component="main" className={classes.main}>
        <CssBaseline />
        <Header released={released} />

        <div className={classes.page}>
          <div className={classes.titleGroup}>
            <Typography className={classes.font24}>本人確認書類一覧</Typography>
          </div>
          {openTable && (
            <Paper className={classes.paper} elevation={1}>
              <div className={classes.pagerInDiv}>
                <div className={classes.shopHeader}>
                  <div className={classes.titleGroupNameDiv}>
                    <Text className={classes.titleGroupName}>確認状況</Text>
                  </div>
                  <div className={classes.textGroupNameDiv}>
                    <Text className={classes.textGroupName}>
                      {identity.statusStr}
                    </Text>
                  </div>
                </div>
                <Typography className={classes.textShopId}>
                  {`グループID: `}
                  {identity.groupId}
                </Typography>
                <Typography className={classes.textShopName}>
                  {identity.groupName}
                </Typography>
                <Table className={classes.tableInfo}>
                  <TableBody>
                    <TableRow>
                      <TableCell className={classes.tableInfoCellHeader}>
                        申請日時
                      </TableCell>
                      <TableCell className={classes.tableInfoCell}>
                        {identity.registeredAt}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableInfoCellHeader}>
                        住所
                      </TableCell>
                      <TableCell className={classes.tableInfoCell}>
                        {identity.address}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                <div className={classes.ngReason}>
                  <Typography>
                    <Text className={[classes.bold, classes.font14]}>
                      NG理由
                    </Text>
                  </Typography>
                  <Typography className={[classes.font14, classes.breakLine]}>
                    {identity.ngReason}
                  </Typography>
                </div>

                <div className={classes.adminMemo}>
                  <Typography>
                    <Text className={[classes.bold, classes.font14]}>
                      事務局メモ
                    </Text>
                  </Typography>
                  <Typography className={[classes.font14, classes.breakLine]}>
                    {identity.adminMemo}
                  </Typography>
                </div>
                <div className={classes.ngReason}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={handleReIdentity}
                    disabled={
                      identity.status !== 'NG' &&
                      identity.status !== 'REJECTION'
                    }
                  >
                    登録
                  </Button>
                </div>

                <Button
                  color="primary"
                  onClick={() => {
                    handleRedirect('/release_group');
                  }}
                  className={classes.btnBack}
                >
                  <Text className={classes.bold}>戻る</Text>
                </Button>
              </div>
            </Paper>
          )}
          <div className={classes.linkToHome}>
            <Button className={classes.button} onClick={signOutAction}>
              <Text className={[classes.bold, classes.font14]}>ログアウト</Text>
            </Button>
          </div>
        </div>

        <PublicFooter />
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </Container>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
